import { Box, Card, CardContent, Typography } from '@mui/material'
import AirIcon from '@mui/icons-material/Air'
import LayersIcon from '@mui/icons-material/Layers'
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone'
import SeedIcon from '@mui/icons-material/Spa'
import LoopIcon from '@mui/icons-material/Loop'
import EditNoteIcon from '@mui/icons-material/EditNote'
import { useScrollReveal } from '../use-scroll-reveal'

const ROADMAP_ITEMS = [
  {
    icon: <PhoneIphoneIcon fontSize="large" />,
    title: 'Android & iOS App',
    description:
      'Native mobile apps so you can check in on your crops, log observations, and track progress from the field — no laptop required.',
  },
  {
    icon: <LayersIcon fontSize="large" />,
    title: 'Polycropping Design',
    description:
      'Full companion planting layers with smart crop placement suggestions — design your polyculture beds with conflict detection and spacing guidance.',
  },
  {
    icon: <SeedIcon fontSize="large" />,
    title: 'Seed Provider Integrations',
    description:
      'Link directly to seed catalogues. Browse variety-specific data and pull growing guides straight into your crop templates.',
  },
  {
    icon: <AirIcon fontSize="large" />,
    title: 'Realtime Weather',
    description:
      'Live weather feeds to drive season progress in near-realtime. Reporting windows shrink from 7 days to a few hours, keeping your plan accurate all season long.',
  },
  {
    icon: <LoopIcon fontSize="large" />,
    title: 'Crop Rotations',
    description:
      'Plan multi-year rotation cycles across your beds. TerraPlanner will track what grew where and warn you before you repeat a family too soon.',
  },
  {
    icon: <EditNoteIcon fontSize="large" />,
    title: 'Smart Journaling',
    description:
      'Log observations, harvests, and issues against specific crops or beds. Patterns surface automatically — so you learn from each season without digging through notes.',
  },
]

const FeatureCard = ({ item, index }) => {
  const { ref, visible } = useScrollReveal(0.15)

  return (
    <Card
      ref={ref}
      elevation={2}
      sx={{
        borderRadius: 3,
        height: '100%',
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(24px)',
        transition: `opacity 0.5s ease ${index * 0.1}s, transform 0.5s ease ${index * 0.1}s`,
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box
          sx={{
            width: 52,
            height: 52,
            borderRadius: 2,
            backgroundColor: 'primary.main',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2,
            opacity: 0.9,
          }}
        >
          {item.icon}
        </Box>
        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
          {item.title}
        </Typography>
        <Typography variant="body2" color="text.secondary" lineHeight={1.65}>
          {item.description}
        </Typography>
      </CardContent>
    </Card>
  )
}

export const RoadmapSection = () => {
  const { ref, visible } = useScrollReveal(0.1)

  return (
    <Box sx={{ py: { xs: 8, md: 12 }, px: { xs: 3, md: 6 }, backgroundColor: 'action.hover' }}>
      <Box sx={{ maxWidth: 900, mx: 'auto' }}>
        <Box
          ref={ref}
          sx={{
            textAlign: 'center',
            mb: 6,
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(20px)',
            transition: 'opacity 0.5s ease, transform 0.5s ease',
          }}
        >
          <Typography variant="overline" color="primary" fontWeight={600} letterSpacing={2}>
            Coming Soon
          </Typography>
          <Typography variant="h4" fontWeight={700} mt={0.5}>
            On the docket
          </Typography>
          <Typography variant="body2" color="text.secondary" mt={1.5} sx={{ maxWidth: 480, mx: 'auto' }}>
            TerraPlanner is actively growing. Here's what's coming next.
          </Typography>
        </Box>

        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 3 }}>
          {ROADMAP_ITEMS.map((item, i) => (
            <FeatureCard key={item.title} item={item} index={i} />
          ))}
        </Box>
      </Box>
    </Box>
  )
}
